(() => {
  const selectBarbecuePlans = '.select-customer-camping-barbecue-plan'
  const barbecuePlanSelectForm = '.customer_camping_barbecue_plan_select_form'
  const selectBarbecueOptions = '.select-customer-camping-barbecue-option'
  const barbecueOptionSelectForm = '.customer_camping_barbecue_option_select_form'
  const selectEvents = '.select-customer-camping-event'
  const eventSelectForm = '.customer_camping_event_select_form'

  const init = () => {
    if (location.href.indexOf('customer/camping/option') < 1 ) {
      return
    }

    $(barbecuePlanSelectForm).hide();
    $(barbecueOptionSelectForm).hide();
    $(eventSelectForm).hide();
    $('body').on('click', selectBarbecuePlans, checkBarbecuePlanForm)
      .on('click', selectBarbecueOptions, checkBarbecueOptionForm)
      .on('click', selectEvents, checkEventForm);
    $(selectBarbecuePlans).each((index, ele) => {
      toggleBarbecuePlanForm(ele)
    })
    $(selectBarbecueOptions).each((index, ele) => {
      toggleBarbecueOptionForm(ele)
    })
    $(selectEvents).each((index, ele) => {
      toggleEventForm(ele)
    })

  }

  const checkBarbecuePlanForm = e => {
    toggleBarbecuePlanForm(e.currentTarget);
  }

  const toggleBarbecuePlanForm = (ele) => {
    $element = $(ele)
    if ($element.prop('checked')) {
      $element.parents('.customer_camping_barbecue_plan_form').find('.barbecue_adult_plan_id').prop('disabled', false);
      $element.parents('.customer_camping_barbecue_plan_form').find('.barbecue_kids_plan_id').prop('disabled', false);
      $element.parents('.customer_camping_barbecue_plan_form').find('.customer_camping_barbecue_plan_select_form').fadeIn();
    } else {
      $element.parents('.customer_camping_barbecue_plan_form').find('.barbecue_adult_plan_id').prop('disabled', true);
      $element.parents('.customer_camping_barbecue_plan_form').find('.barbecue_kids_plan_id').prop('disabled', true);
      $element.parents('.customer_camping_barbecue_plan_form').find('.customer_camping_barbecue_plan_select_form').fadeOut();
    }
  }

  const checkBarbecueOptionForm = e => {
    toggleBarbecueOptionForm(e.currentTarget);
  }
  const toggleBarbecueOptionForm = ele => {
    const $element = $(ele);
    if ($element.prop('checked')) {
      $element.parents('.customer_camping_barbecue_option_form').find('.customer-camping-barbecue-option-id').prop('disabled', false);
      $element.parents('.customer_camping_barbecue_option_form').find('.customer-camping-barbecue-option-reserve-date').prop('disabled', false);
      $element.parents('.customer_camping_barbecue_option_form').find('.camping_barbecue_option_num').prop('disabled', false);
      $element.parents('.customer_camping_barbecue_option_form').find('.customer_camping_barbecue_option_select_form').fadeIn();
    } else {
      $element.parents('.customer_camping_barbecue_option_form').find('.customer-camping-barbecue-option-id').prop('disabled', true);
      $element.parents('.customer_camping_barbecue_option_form').find('.customer-camping-barbecue-option-reserve-date').prop('disabled', true);
      $element.parents('.customer_camping_barbecue_option_form').find('.camping_barbecue_option_num').prop('disabled', true);
      $element.parents('.customer_camping_barbecue_option_form').find('.customer_camping_barbecue_option_select_form').fadeOut();
    }
  }

  const checkEventForm = e => {
    toggleEventForm(e.currentTarget)
  }
  const toggleEventForm = ele => {
    const $element = $(ele);
    if ($element.prop('checked')) {
      $element.parents('.customer_camping_event_form').find('.camping_event_id').prop('disabled', false);
      $element.parents('.customer_camping_event_form').find('.camping_event_adult_num').prop('disabled', false);
      $element.parents('.customer_camping_event_form').find('.camping_event_kids_num').prop('disabled', false);
      $element.parents('.customer_camping_event_form').find('.customer_camping_event_select_form').fadeIn();
    } else {
      $element.parents('.customer_camping_event_form').find('.camping_event_id').prop('disabled', true);
      $element.parents('.customer_camping_event_form').find('.camping_event_adult_num').prop('disabled', true);
      $element.parents('.customer_camping_event_form').find('.camping_event_kids_num').prop('disabled', true);
      //$element.parents('.customer_camping_event_form').find('.camping_event_adult_num').val('0');
      //$element.parents('.customer_camping_event_form').find('.camping_event_kids_num').val('0');
      $element.parents('.customer_camping_event_form').find('.customer_camping_event_select_form').fadeOut();
    }
  }
  $(init);
})();

